export const pressRelease = [
  {
    title:
      "QuantaRock Systems Expands Its Edge Infrastructure with a New Datacenter in Ahmedabad",
    url: "https://www.prlog.org/13153474-quantarock-systems-expands-its-edge-infrastructure-with-new-datacenter-in-ahmedabad.html",
    date: "June 21, 2026",
    summary:
      "QuantaRock Systems announced the launch of its new Edge Datacenter in Ahmedabad, expanding its nationwide digital infrastructure footprint. The facility is designed to provide low-latency connectivity, enhanced network performance, high availability, and scalable infrastructure to support cloud adoption, content delivery, enterprise applications, and edge computing workloads. Strategically located in Ahmedabad, the datacenter will enable businesses to deploy workloads closer to end users, improving application performance, reducing latency, and strengthening operational resilience across Western India.",
    source: "PRLog",
  },
  {
    title: "QuantaRock Systems Launches Edge Data Center in Bangalore",
    url: "https://www.openpr.com/news/4456669/quantarock-systems-launches-edge-data-center-in-bangalore",
    date: "February 21, 2026",
    summary:
      "QuantaRock Systems announces the launch of its new edge data center in Bangalore, strengthening its presence in India’s digital infrastructure landscape. The facility is designed to deliver low-latency connectivity, scalable colocation services, high-performance cloud integration, and enterprise-grade security to support growing AI, cloud, and business-critical workloads across South India.",
    source: "openPR",
  },
  {
    title: "AI That Assists — Not Replaces",
    url: "https://www.prlog.org/13113841-ai-that-assists-not-replaces.html",
    date: "November 30, 2025",
    summary:
      "QuantaRock Systems announces an upcoming AI-empowered mobile application designed to transform engineering workflows with intelligent diagnostics, real-time calculators, guided troubleshooting, and auto-generated reporting — built to assist engineers, not replace them.",
    source: "PRLog",
  },
  {
    title:
      "QuantaRock Systems Resolves Complex Legacy Infrastructure Challenge, Boosts Efficiency by 64%",
    url: "https://www.prlog.org/13061804-quantarock-systems-resolves-complex-legacy-infrastructure-challenge-boosts-efficiency-by-64.html",
    date: "April 19, 2025",
    summary:
      "QuantaRock Systems Overcomes Complex Legacy Infrastructure Challenges, Driving Efficiency Gains and Cost Reduction — All Without Disrupting Production",
    source: "PRLog",
  },
  {
    title:
      "QuantaRock Systems: Transforming IT Infrastructure with Cutting-Edge Solutions",
    url: "https://www.openpr.com/news/3867604/quantarock-systems-transforming-it-infrastructure-with",
    date: "February 13, 2025",
    summary:
      "QuantaRock Systems announces its latest initiatives to modernize enterprise IT infrastructure with a focus on automation, scalability, and performance.",
    source: "OpenPR",
  },
];

export const ALL_DETAIL_ROUTES_INFO = [...pressRelease];
